import React from 'react'

import { resolveBlock } from '~/components/serializers'

import SignupPageHeader from './SignupPageHeader/SignupPageHeader'

import styles from './SignupPage.module.css'

interface PageData {
  title?: string
  summary?: any
  pageBlocks?: any
}

const SignupPage = (props: PageData) => {
  const { pageBlocks } = props

  return (
    <div className={styles.base}>
      <SignupPageHeader title={props.title} summary={props.summary} />
      {pageBlocks && (
        <div className={styles.body}>
          {pageBlocks.map((block: any, i: any) => resolveBlock(block, i))}
        </div>
      )}
    </div>
  )
}

export default SignupPage
